import { render, staticRenderFns } from "./UnitBulkRevenueManager.vue?vue&type=template&id=bc7111d4&"
import script from "./UnitBulkRevenueManager.vue?vue&type=script&lang=js&"
export * from "./UnitBulkRevenueManager.vue?vue&type=script&lang=js&"
import style0 from "./UnitBulkRevenueManager.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports